<div class="product-price">
    @if (loading()) {
        <div class="skeleton-wrapper">
            <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
        </div>
    } @else {
        <!-- Prices are loaded in Shopping Dollars; shown as whole numbers, no US dollar equivalent. -->
        <div class="money">
            <h3 class="new-value cta">{{ newPrice() | appDigitsGrouping }} {{ rewardName() }}</h3>
            @if (oldPrice()) {
                <h3 class="body-0 old-price">{{ oldPrice() | appDigitsGrouping }} {{ rewardName() }}</h3>
            }
        </div>
    }
</div>
